import script from "./recruitList.vue?vue&type=script&lang=ts&setup=true"
export * from "./recruitList.vue?vue&type=script&lang=ts&setup=true"

import "./recruitList.vue?vue&type=style&index=0&id=4f894a4e&lang=less"

const __exports__ = script;

export default __exports__